import { render, staticRenderFns } from "./lowPriceUndistributed.vue?vue&type=template&id=0cc3753c&scoped=true"
import script from "./lowPriceUndistributed.vue?vue&type=script&lang=js"
export * from "./lowPriceUndistributed.vue?vue&type=script&lang=js"
import style0 from "./lowPriceUndistributed.vue?vue&type=style&index=0&id=0cc3753c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3753c",
  null
  
)

export default component.exports